import React, { useState } from 'react'

import {
  InputHLPure,
  ButtonHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
} from '../../../pures'
import { useTranslation } from 'react-i18next'
import './user-administration-add-new-user.view.css'
import { profileIconDefault } from '../../../../assets/logos/icons'

const UserAdministrationAddNewUserView = ({
  selectedUser,
  hideShowDetails,
  validators,
  saveNewUser,
  token,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showWarningRequesting,
  toggleWarningRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
}) => {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [errorInEmail, setErrorInEmail] = useState(false)

  const handleEmailInput = (e) => {
    setEmail(e.target.value)
  }

  const handleSave = () => {
    let invalidateEmail = validators.emailValidator(email)
    if (invalidateEmail) {
      setErrorInEmail(true)
    } else {
      setErrorInEmail(false)
      const body = {
        email: email,
      }
      saveNewUser(token, body)
    }
  }

  return (
    <div className='userAdministrationAddNewUserView-wrapper'>
      <>
        <header className='userAdministrationAddNewUserView-subtitle'>
          <SubtitlePageHLPure
            subtitle={t('userAdministrationAddNewUserView.addUser')}
            imgProfile={profileIconDefault}
            profileImg={imgProfileSubtitle}
            tooltipShow={false}
          />
        </header>
        <div className='userAdministrationAddNewUserView-body'>
          <div className='userAdministrationAddNewUserView-form'>
            <div className='userAdministrationAddNewUserView-textAreaHLPure'>
              <InputHLPure
                labelInput={t('userAdministrationAddNewUserView.email')}
                valueInput={email}
                handleChangeInput={handleEmailInput}
                typeInput={'text'}
                errorInputText={t(
                  'userAdministrationAddNewUserView.errorEmail'
                )}
                errorInput={errorInEmail}
                inputActive
              />
            </div>
          </div>
          <div className='userAdministrationAddNewUserView-btnGroup'>
            <div className='userAdministrationAddNewUserView-spaceBtns'>
              <ButtonHLPure
                nameBtn={t('button.return')}
                onClickBtn={hideShowDetails}
                primary={false}
              />
            </div>
            <ButtonHLPure primary nameBtn={t('button.save')} onClickBtn={handleSave} />
          </div>
        </div>
        <DialogSystemGLPure
          showLoadingRequesting={showLoadingRequesting}
          showCompletedRequesting={showCompletedRequesting}
          showErrorRequesting={showErrorRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
          toggleCompletedRequesting={toggleCompletedRequesting}
          toggleErrorRequesting={toggleErrorRequesting}
          toggleWarningRequesting={toggleWarningRequesting}
          showWarningRequesting={showWarningRequesting}
          message={message}
        />
      </>{' '}
    </div>
  )
}

export default UserAdministrationAddNewUserView
